import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDartComponent } from './simple-icons-dart.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDartComponent ],
    exports:      [ SimpleIconsDartComponent ],
    bootstrap:    []
})
export class SimpleIconsDartModule {}
